module.exports = __webpack_public_path__ + "static/media/MERM-MOSTAZA.7a86af9f.webp";